import {NgModule} from '@angular/core';
import {SafeHtmlSanitizerPipe} from './safe-html-sanitizer.pipe';

@NgModule({
	declarations: [SafeHtmlSanitizerPipe],
	exports: [SafeHtmlSanitizerPipe]
})
export class SafeHtmlSanitizerModule {
}
